import { render, staticRenderFns } from "./CompositeProductCompositionThumbs.vue?vue&type=template&id=23a8afcc&scoped=true&"
import script from "./CompositeProductCompositionThumbs.vue?vue&type=script&lang=js&"
export * from "./CompositeProductCompositionThumbs.vue?vue&type=script&lang=js&"
import style0 from "./CompositeProductCompositionThumbs.vue?vue&type=style&index=0&id=23a8afcc&lang=scss&scoped=true&"
import style1 from "./CompositeProductCompositionThumbs.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "23a8afcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
